class FetchInvitation {
	constructor(public readonly token: string) {
		Object.freeze(this);
	}
}

export default FetchInvitation;
